import styled from "styled-components";

import ResetIcon from "icons/reset";

interface ResetMapButtonProps {
  onResetAction: () => void;
}

const Reset = styled.button`
  position: absolute;
  top: 10px;
  right: 80px;
  background: #ffffff;
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  height: 34px;
  width: 34px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  :hover {
    cursor: pointer;
  }
`;

const ResetMapButton = ({ onResetAction }: ResetMapButtonProps) => {
  return (
    <Reset
      onClick={() => {
        onResetAction();
      }}
    >
      <ResetIcon />
    </Reset>
  );
};

export default ResetMapButton;
